import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SendingModalRemoteService } from "@modules/main/components/step-summary/sending-modal/services/sending-modal-remote.service";
import { map } from "rxjs/operators";
import { WalletBalanceApiModel } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.api.model";

@Injectable()
export class SendAmountService {
	constructor(private readonly sendRemote: SendingModalRemoteService) {}

	public getBalances$(walletId: string): Observable<WalletBalanceApiModel> {
		return this.sendRemote
			.getBalance$()
			.pipe(map((res) => res.cryptocoin_wallets.find((item) => item.id === walletId)));
	}
}
